import templateStr from 'text!./templates/ho-view-coverages.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwPcHoViewCoverages',
            filterSelected: '@'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/ho/directives/HOViewCoverages.js
// module id = 1193
// module chunks = 0